var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 16 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M1.2045 1.2045C1.64384 0.765165 2.35616 0.765165 2.7955 1.2045L8 6.40901L13.2045 1.2045C13.6438 0.765165 14.3562 0.765165 14.7955 1.2045C15.2348 1.64384 15.2348 2.35616 14.7955 2.7955L8.7955 8.7955C8.35616 9.23483 7.64384 9.23483 7.2045 8.7955L1.2045 2.7955C0.765165 2.35616 0.765165 1.64384 1.2045 1.2045Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }